import { getMyFirmList } from "@/sideEffects/api";
import { useQuery } from "@tanstack/react-query";

export const useMyFirmList = () => {
  const firmListData = useQuery({
    queryKey: ["getMyFirmList"],
    queryFn: getMyFirmList,
    // We force the query to be stale indefinetely
    staleTime: Infinity,
  });

  return {
    firmList: firmListData.data?.data || [],
    isLoading: firmListData.isLoading,
    isError: firmListData.isError,
  };
};
